import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppShell from "../components/AppShell";
import { useContent } from "../hooks/useContent";
import T from "../components/T";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SECTIONS = [
  { id: "patterns", key: "library.section_patterns" },
  { id: "tactics",  key: "library.section_tactics" },
  { id: "recovery", key: "library.section_recovery" },
];

export default function Library() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { LIBRARY } = useContent();

  return (
    <AppShell>
      <div className="px-8 pt-16 pb-6" data-testid="page-library">
        <button data-testid="library-back" onClick={() => navigate(-1)} className="flex items-center gap-1 text-sm text-foreground/55 hover:text-brand mb-2">
          <ChevronLeft className="w-4 h-4" /> {t("common.back")}
        </button>
        <p className="font-script text-2xl text-brand">{t("library.kicker")}</p>
        <h1 className="font-serif text-4xl leading-tight">
          <T i18nKey="library.h" />
        </h1>
        <p className="mt-3 text-foreground/70 leading-relaxed">{t("library.intro")}</p>
      </div>

      <div className="px-8 pb-10 space-y-7">
        {SECTIONS.map((sec) => {
          const items = LIBRARY.filter((l) => (l.section || "tactics") === sec.id);
          if (items.length === 0) return null;
          return (
            <section key={sec.id} data-testid={`library-section-${sec.id}`}>
              <h2 className="text-xs uppercase tracking-widest text-foreground/55 mb-3">
                {t(sec.key)}
              </h2>
              <div className="space-y-3">
                {items.map((l) => (
                  <Link
                    key={l.slug}
                    to={`/library/${l.slug}`}
                    data-testid={`library-item-${l.slug}`}
                    className="block rounded-3xl bg-card border border-border p-5 hover:border-brand/50 transition-all"
                  >
                    <div className="flex items-center justify-between gap-3">
                      <div className="flex-1">
                        <div className="font-serif text-xl">{l.title}</div>
                        <p className="text-sm text-foreground/70 mt-1">{l.short}</p>
                      </div>
                      <ChevronRight className="w-4 h-4 text-foreground/40 shrink-0" />
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </AppShell>
  );
}
